// CANVAS & LAYOUT
export const DEVICE_VIEW_CHANGED = 'Device View Changed';

// PAGE MANAGEMENT
export const NEW_PAGE_CREATED = 'New Page Created';

// CONTENT & STRUCTURE
export const ELEMENT_ADDED = 'Element Added';
export const LAYERS_REORDERED = 'Layers Reordered';
export const ELEMENT_DELETED = 'Element Deleted';
export const SECTION_SAVED = 'Section Saved';

// EDIT & STYLING
export const TEXT_EDITED = 'Text Edited';
export const IMAGE_ADDED = 'Image Added';
export const PAGE_STYLES_EDITED = 'Page Styles Edited';
export const UNDO_USED = 'Undo Used';
export const REDO_USED = 'Redo Used';

// AI GENERATION
export const AI_GENERATION = 'AI Generation';
export const AI_STAGE_COMPLETED = 'AI Stage Completed';

// INSPIRATION PAGES
export const OPENED_INSPIRATION_GALLERY = 'Opened Inspiration Gallery';
export const PREVIEWED_INSPIRATION_PAGE = 'Previewed Inspiration Page';
export const USED_INSPIRATION_PAGE = 'Used Inspiration Page';

// PREVIEW, SETTINGS, & PUBLISH, UPDATE, REPUBLISH
export const PREVIEW_CLICKED = 'Preview Clicked';
export const PUBLISH_CLICKED = 'Publish Clicked';
export const PUBLISH_COMPLETED = 'Publish Completed';
export const PUBLISH_FAILED = 'Publish Failed';
export const UPDATE_CLICKED = 'Update Clicked';
export const UPDATE_COMPLETED = 'Update Completed';
export const UPDATE_FAILED = 'Update Failed';
export const REPUBLISH_CLICKED = 'Republish Clicked';
export const REPUBLISH_COMPLETED = 'Republish Completed';
export const REPUBLISH_FAILED = 'Republish Failed';
export const SETTINGS_DOMAIN_EDITED = 'Settings Domain Edited';
export const SETTINGS_SEO_EDITED = 'Settings SEO Edited';
export const SETTINGS_SOCIAL_EDITED = 'Settings Social Edited';
export const SETTINGS_ANALYTICS_EDITED = 'Settings Analytics Edited';

// UPGRADE MODAL
export const UPGRADE_MODAL_SHOWN = 'Upgrade Modal Shown';
export const UPGRADE_MODAL_UPGRADE_CLICKED = 'Upgrade Modal Upgrade Clicked';
export const UPGRADE_MODAL_DISMISSED = 'Upgrade Modal Dismissed';

// INTEGRATIONS & AUTOMATION
export const VIEWED_INTEGRATIONS_PANEL = 'Viewed Integrations panel';
export const CLICKED_ADD_A_FORM = 'Clicked Add a form';
export const CLICKED_SET_UP_AUTOMATION = 'Clicked Set up automation';
export const CLICKED_NEW_AUTOMATION = 'Clicked New automation';
export const VIEWED_AUTOMATION_STEP = 'Viewed automation step';
export const SELECTED_AN_INTEGRATION = 'Selected an integration';
export const CLICKED_CONNECT_AN_INTEGRATION = 'Clicked Connect an integration';
export const COMPLETED_FIELD_MAPPING = 'Completed field mapping';
export const ACTIVATED_AN_AUTOMATION = 'Activated an automation';
export const AUTOMATION_ACTIVATION_FAILED = 'Automation activation failed';
export const EDITED_AN_AUTOMATION = 'Edited an automation';
export const EXITED_AUTOMATION_SETUP = 'Exited automation setup';
export const CONNECTED_AN_INTEGRATION = 'Connected an integration';
